import { Mission1 } from './mission1'
import { Mission2 } from './mission2'
import { Mission3 } from './mission3'
import { Mission4 } from './mission4'

export default [Mission1, Mission2, Mission3, Mission4]